/**
 * Canonical wire-string registry for audit `resourceType` values.
 * Mirrors BE `@Auditable` annotations + per-scope overrides.
 *
 * Notes:
 * - Tenant emits `CLIENT` (rebrand). Legacy `TENANT` rows are gone.
 * - Signing requests emit `SIGNING_REQUEST`. Mongo rows predating the rename
 *   keep `ENVELOPE` — querying by the new value will not surface them.
 * - Form templates: per-scope via `FormTemplateServiceImpl.scopedResourceType`
 *   (`CLIENT_TEMPLATE` / `LEGAL_ENTITY_TEMPLATE` / `EMPLOYEE_TEMPLATE`).
 * - Form data: collapses under the owning entity via
 *   `FormDataServiceImpl.resourceTypeFor` — no `*_FORM` values on the wire.
 *   A form-data edit on a tenant surfaces as `CLIENT_UPDATED` in the parent
 *   tenant's audit trail, so FE has no per-form audit trigger.
 */
export const AUDIT_RESOURCE = {
  CLIENT: 'CLIENT',
  LEGAL_ENTITY: 'LEGAL_ENTITY',
  EMPLOYEE: 'EMPLOYEE',
  EMPLOYMENT_TYPE: 'EMPLOYMENT_TYPE',
  USER: 'USER',
  ROLE: 'ROLE',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE',
  COMMERCIAL_TERM: 'COMMERCIAL_TERM',
  MODULE_MAPPING: 'MODULE_MAPPING',
  FORM_CONFIG: 'FORM_CONFIG',
  CLIENT_TEMPLATE: 'CLIENT_TEMPLATE',
  LEGAL_ENTITY_TEMPLATE: 'LEGAL_ENTITY_TEMPLATE',
  EMPLOYEE_TEMPLATE: 'EMPLOYEE_TEMPLATE',
  DOCUMENT_TEMPLATE: 'DOCUMENT_TEMPLATE',
  SIGNING_REQUEST: 'SIGNING_REQUEST',
  DEPARTMENT: 'DEPARTMENT',
  JOB_TITLE: 'JOB_TITLE',
} as const;

export type AuditResourceType = (typeof AUDIT_RESOURCE)[keyof typeof AUDIT_RESOURCE];
